var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", [_vm._v("各種書類")]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticStyle: { float: "right", padding: "3px 0" },
            attrs: { type: "text" },
            on: { click: _vm.top }
          },
          [_vm._v("戻る")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "table-area" }, [
      _c("table", { staticClass: "table table-bordered" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("カテゴリー")]),
            _vm._v(" "),
            _c("th", [_vm._v("書類名")]),
            _vm._v(" "),
            _c("th", [_vm._v("書類概要")]),
            _vm._v(" "),
            _c("th", [_vm._v("ダウンロード")])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.documents, function(row, index) {
            return _c("tr", { key: index }, [
              _c("td", [_vm._v(_vm._s(row.category_name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(row.name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(row.description))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center" }, [
                _c("a", { attrs: { href: row.download_url, download: "" } }, [
                  _c("i", { staticClass: "el-icon-download" })
                ])
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }